<template>
    <div class="page page__list">
        <search-bar @search="onSearch" name="ex_name" placeholder="请输入关键字搜索" ref="searchBar" />
        <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
        <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
            <router-link class="weui-cell weui-cell_access" v-for="item in items" :key="item.eu_id"
                :to="'/oa/exam_user/' + item.eu_id">
                <div class="weui-cell__bd">
                    <p>{{ item.ex_name }}</p>
                </div>
                <div class="weui-cell__ft">
                    <p>{{ item.eu_emname }}</p>
                    <span class="list-item-status" :class="{ 'warning': item.eu_status < 3 }">{{
            parseStatus(item.eu_status) }}</span>
                </div>
            </router-link>
        </scroll-list>
        <div class="list-footer">
            <label class="list-footer__label">合计：{{ items.length }}场</label>
        </div>
    </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
    components: {
        SearchBar,
        FilterBar,
        ScrollList
    },
    mixins: [list],
    data() {
        return {
            listUrl: "/api/oa/exam_user/list",
            filters: [
                {
                    type: "date",
                    name: "exam.createTime"
                },
                {
                    type: "condition",
                    label: "状态",
                    value: -1,
                    options: [
                        {
                            value: -1,
                            label: "全部"
                        },
                        {
                            value: 1,
                            label: "未开始",
                            condition: "eu_status=0"
                        },
                        {
                            value: 1,
                            label: "已开始未完成",
                            condition: "eu_status=1"
                        },
                        {
                            value: 2,
                            label: "已完成未批阅",
                            condition: "eu_status=2"
                        },
                        {
                            value: 3,
                            label: "已完成已批阅",
                            condition: "eu_status=3"
                        }
                    ]
                }
            ]
        };
    },
    methods: {
        parseStatus(status) {
            return ['未开始', '已开始未完成', '已完成未批阅', '已完成已批阅'][status]
        }
    }
};
</script>